var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('editor',{ref:"myEditor",staticStyle:{"height":"60vh"},attrs:{"project-id":_vm.projectId,"tools":_vm.tools},on:{"load":_vm.editorLoaded,"ready":_vm.editorReady}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }